<script setup lang="ts">
import { useDayjs } from "#dayjs"
import type { MenuOption } from "naive-ui"
import { NIcon } from "naive-ui"
import { DocumentTextOutline } from "@vicons/ionicons5"

const router = useRouter()
const value = ref()

watch(
    () => router.currentRoute.value.name,
    (v) => {
        value.value = v
    },
    {
        immediate: true,
    },
)

const collapsed = ref(false)

function renderIcon(icon: Component) {
    return () => h(NIcon, null, { default: () => h(icon) })
}

function onChangeValue(v: string) {
    router.push({ name: v })
}

const menuOptions: MenuOption[] = [
    {
        label: () => "预约看板",
        key: "reservation-dashboard",
        icon: renderIcon(DocumentTextOutline),
    },
    {
        label: () => "可视化看板",
        key: "reservation-visualization",
        icon: renderIcon(DocumentTextOutline),
    },
    {
        label: () => "预约管理",
        key: "reservation-list",
        icon: renderIcon(DocumentTextOutline),
    },
    {
        label: () => "新增预约",
        key: "reservation-new",
        icon: renderIcon(DocumentTextOutline),
    },
    {
        label: () => "故障提报",
        key: "reservation-fault",
        icon: renderIcon(DocumentTextOutline),
    },
    {
        label: () => "服务设置",
        key: "reservation-service",
        icon: renderIcon(DocumentTextOutline),
    },
    {
        label: () => "门店服务",
        key: "reservation-store",
        icon: renderIcon(DocumentTextOutline),
    },
    {
        label: () => "消息配置",
        key: "reservation-message",
        icon: renderIcon(DocumentTextOutline),
    },
    {
        label: () => "消息发送",
        key: "reservation-message-send",
        icon: renderIcon(DocumentTextOutline),
    },
    {
        label: () => "邮箱配置",
        key: "reservation-mail",
        icon: renderIcon(DocumentTextOutline),
    },
]

const { t, locale, locales, setLocale } = useI18n()

const langOptions = computed(() => {
    return locales.value.map((v) => {
        if (typeof v === "string") {
            return {
                label: v,
                value: v,
            }
        }
        return {
            label: v.name,
            value: v.code,
        }
    })
})

async function onChange(v: string) {
    await setLocale(v).then(() => {
        useDayjs().locale(v === "en" ? "en-sg" : v)
    })
}
</script>

<template>
    <NLayoutSider
        bordered
        collapse-mode="width"
        :width="240"
        :collapsed="collapsed"
        show-trigger
        @collapse="collapsed = true"
        @expand="collapsed = false"
        style="z-index: 10"
    >
        <NMenu
            accordion
            :value="value"
            :collapsed="collapsed"
            :options="menuOptions"
            @update:value="onChangeValue"
        />
        <NSelect
            v-if="!collapsed"
            style="padding: 10px"
            size="small"
            :value="locale"
            :options="langOptions"
            @update:value="onChange"
        />
    </NLayoutSider>
</template>
